import { render, staticRenderFns } from "./CreateOrderButton.vue?vue&type=template&id=e392bf5a&scoped=true"
import script from "./CreateOrderButton.vue?vue&type=script&lang=ts"
export * from "./CreateOrderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e392bf5a",
  null
  
)

export default component.exports